import getEcommLinkWithWalletData from './getEcommLinkWithWalletData';

export default getEcommLinkWithWalletData;
